import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import sliderTitleDiscountStyles from './sliderTitleDiscountStyles';
import IMoney from '../../../../../../gqlCommon/model/prices/IMoney';
import useSelectedCurrencyDiscountPrice from '../../../../../../gqlCommon/hooks/currency/useSelectedCurrencyDiscountPrice';
import Price from '../../../../../../gqlCommon/components/presentation/Price';
import { usePersistedCurrencyPreference } from '../../../../../../gqlCommon/hooks/currency/usePersistedCurrencyPreference';
import Translation from '../../../../../../common/components/translation/Translation';
import { PriceDisplayType } from '../../../../../../../../common/enum/PriceDisplayType';

export interface ISliderTitleDiscount {
  prices: IMoney[];
  currency: string;
  loading?: boolean;
}

const SliderTitleDiscount: FunctionComponent<ISliderTitleDiscount> = ({ currency, prices, loading }) => {
  const styles = sliderTitleDiscountStyles();
  const { selectedCurrencyDiscountPrice } = useSelectedCurrencyDiscountPrice(prices);
  const { isSecondaryCurrencyDisplay } = usePersistedCurrencyPreference();

  return (
    <Box justifyContent={'space-between'} alignItems="center" className={styles.container}>
      <Box className={styles.label}>
        {/*@TODO remove defaultMessage and update translation path when more info are available*/}
        <Typography variant="body1">
          <Translation
            id={'trans__configurator__discounts__customise_page_total_discount_label'}
            defaultMessage="Bonuses Applied"
          />
        </Typography>
      </Box>
      <Box data-test={`sliderTitle:discount:total_discount`}>
        <Price
          className={styles.priceValue}
          loading={loading}
          price={selectedCurrencyDiscountPrice}
          currency={currency}
          priceDisplayType={isSecondaryCurrencyDisplay ? PriceDisplayType.SECONDARY : PriceDisplayType.PRIMARY}
        />
      </Box>
    </Box>
  );
};

export default SliderTitleDiscount;
